/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Org_Empty_OkInputs */

const cs_portals_org_empty_ok = /** @type {(inputs: Portals_Org_Empty_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Všechny kontrolované portály vypadají aktuálně.`)
};

const en_portals_org_empty_ok = /** @type {(inputs: Portals_Org_Empty_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All checked portals look up to date.`)
};

/**
* | output |
* | --- |
* | "All checked portals look up to date." |
*
* @param {Portals_Org_Empty_OkInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_org_empty_ok = /** @type {((inputs?: Portals_Org_Empty_OkInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Org_Empty_OkInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_org_empty_ok(inputs)
	return cs_portals_org_empty_ok(inputs)
});